import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, onMounted, ref } from 'vue'
import { getImage, QuestionnaireView } from '@/models/onboarding'
import type { LoadingPage } from '@/models/onboarding.types'

import Rive from '@/app/components/Rive.vue'
import Layout from '../Layout.vue'
import { waitTimer } from '@/helpers/timer'


export default /*@__PURE__*/_defineComponent({
  __name: 'Loading',
  props: {
    view: {}
  },
  setup(__props: any) {

const props = __props

const page = computed(() => {
  return props.view.currentPage as LoadingPage
})

const isLoading = ref(true)

const currentAnimation = computed(() => {
  return isLoading.value ? 'loading' : 'loaded'
})

const currentTitle = computed(() => {
  return isLoading.value ? page.value.title : page.value.titleDone
})

onMounted(async () => {
  // This component was previously used as a loading screen while the First
  // Reading List was being created, so there is a 3-second wait here.
  // But the first reading lists are now created later on; see #18992.
  // So this 3-second wait is probably no longer needed (and the component
  // is no longer used anyway), but we keep it here in case future
  // onboarding work expects it.
  await waitTimer(3000)
  isLoading.value = false
  props.view.showContinueButton()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Layout, {
    class: "onboarding-loading",
    title: currentTitle.value,
    titleTransition: true
  }, {
    aboveTitle: _withCtx(() => [
      _createVNode(Rive, {
        class: "onboarding-loading__rive",
        src: _unref(getImage)(page.value.animation.src),
        width: page.value.animation.width,
        height: page.value.animation.height,
        animations: currentAnimation.value,
        fit: "FitWidth",
        alignment: "BottomCenter"
      }, null, 8, ["src", "width", "height", "animations"])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})